class AutoGeneratedContent {
  constructor(containerElement) {
    this.buttonElement = containerElement?.querySelector('.js-autogenerated-text');
    this.modalElement = containerElement?.querySelector('.js-tooltip');
    this.modalCloseIcon = containerElement?.querySelector('.js-close');
    this.isOpen = false;
  }

  init() {
    if (!this.buttonElement) {
      return;
    }

    this.buttonElement.addEventListener('click', () => {
      if (this.isOpen) {
        this.handleCloseModal();
        return;
      }

      this.handleOpenModal();
    });
  }

  toggleVisibily() {
    this.modalElement?.classList.toggle('open');
    this.buttonElement?.classList.toggle('open');
  }

  handleCloseModal() {
    this.isOpen = false;
    this.toggleListeners();
    this.toggleVisibily();
  }

  handleOutsideClickListener = e => {
    if (this.modalCloseIcon?.contains(e.target)) {
      this.handleCloseModal();
      return;
    }

    if (this.buttonElement?.contains(e.target) || this.modalElement?.contains(e.target)) {
      return;
    }

    this.handleCloseModal();
  }

  toggleListeners() {
    if (this.isOpen) {
      document.addEventListener('mousedown', this.handleOutsideClickListener);
      document.addEventListener('touchstart', this.handleOutsideClickListener);
      return;
    }

    document.removeEventListener('mousedown', this.handleOutsideClickListener);
    document.removeEventListener('touchstart', this.handleOutsideClickListener);
  }

  handleOpenModal() {
    this.isOpen = true;
    this.toggleListeners();
    this.toggleVisibily();
  }
}

const initAutoGeneratedContent = container => new AutoGeneratedContent(container).init();

export {initAutoGeneratedContent};
